// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tYHM","title":"Info_title__Dz0x-","links":"Info_links__2ze3Q","link":"Info_link__1-bB-","logo":"Info_logo__1Vd6E"};